import { ChangeEventHandler, FC } from 'react';
import SectionHead from '../../SectionHead';
import CompanyInfoForm from '../CompanyInfoForm';
import styles from './styles.module.css';
import { useFormContext } from 'react-hook-form';
import { ContractFormData } from '../../../../../types/contracts';
import CheckBox from '../../../../../components/common/CheckBox';

const setValueOpt = {
  shouldValidate: true,
  shouldDirty: true,
  shouldTouch: true,
};
const WastePointCompany: FC = () => {
  const { setValue, watch } = useFormContext<ContractFormData>();
  const value = watch('wastePointCompanyIsTheSameSupplier');
  const onCheck: ChangeEventHandler<HTMLInputElement> = (e) => {
    const checked = e.target.checked;
    setValue('wastePointCompanyIsTheSameSupplier', checked, setValueOpt);
  };
  return (
    <>
      <SectionHead>
        <div className={styles.label}>
          排出事業場情報
          <div className={styles.checkbox}>
            <CheckBox
              label="排出事業者と同じ"
              checked={value}
              onChange={onCheck}
            />
          </div>
        </div>
      </SectionHead>
      {!value && <CompanyInfoForm namePrefix={'wastePointCompanyInfo'} />}
    </>
  );
};
export default WastePointCompany;
